<template>
  <section>
    <RevCardCarousel
      :center="true"
      desktop-card-width="wider"
      mobile-card-width="standard"
      :next-alternative-text="i18n(translations.alternativeNext)"
      :prev-alternative-text="i18n(translations.alternativePrevious)"
      size="large"
      :title="i18n(translations.title)"
    >
      <RevCard
        v-for="review in reviews"
        :key="review.author"
        class="flex h-full flex-col items-center justify-center gap-16 p-24 text-center"
      >
        <RevRating :score="review.score" size="small" />

        <q class="heading-3 select-text">{{ review.text }}</q>

        <p class="body-2 text-static-default-low">
          {{ review.author }}
        </p>
      </RevCard>
    </RevCardCarousel>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevRating } from '@ds/components/Rating'

import translations from './ReviewsCarousel.translations'

const i18n = useI18n()

const reviews = computed(() => [
  {
    score: parseFloat(i18n(translations.review1Score)),
    text: i18n(translations.review1Text),
    author: i18n(translations.review1Author),
  },
  {
    score: parseFloat(i18n(translations.review2Score)),
    text: i18n(translations.review2Text),
    author: i18n(translations.review2Author),
  },
  {
    score: parseFloat(i18n(translations.review3Score)),
    text: i18n(translations.review3Text),
    author: i18n(translations.review3Author),
  },
  {
    score: parseFloat(i18n(translations.review4Score)),
    text: i18n(translations.review4Text),
    author: i18n(translations.review4Author),
  },
  {
    score: parseFloat(i18n(translations.review5Score)),
    text: i18n(translations.review5Text),
    author: i18n(translations.review5Author),
  },
])
</script>
